import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_EQM1010_R01 } from "./Content_EQM1010_R01";
import { Info_EQM1010_R01 } from "./Info_EQM1010_R01";
import { SearchSection_EQM1010_R01 } from "./SearchSection_EQM1010_R01";
import { Table_EQM1010_R01 } from "./Table_EQM1010_R01";

/**
 * KPI 실적 조회 컨테이너 컴포넌트
 * KPI 실적 조회 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_EQM1010_R01 = () => {
    const { setMessage } = useUiuxStore();

    // Content에서 액션바 핸들러 함수들을 가져옴
    const {
        fetchData,
        handleExcelClick,
        handleInitClick,
    } = Content_EQM1010_R01({
        setMessage,
    });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onSaveClick={undefined} 
                onDeleteClick={() => {}}
                onInitClick={handleInitClick}
                onExcelClick={handleExcelClick}
                onPrintClick={() => {}}
            />
            
            {/* KPI 실적 검색 섹션 */}
            <SearchSection_EQM1010_R01 />
            
            <Info_EQM1010_R01 />
            
            <div className="flex flex-1 p-[12px] gap-[4px] min-h-0">
                <div className="h-full w-full">
                    {/* KPI 실적 테이블 */}
                    <Table_EQM1010_R01 />
                </div>
            </div>
            
            {/* 메시지 표시 컴포넌트 */}
            <Message />
        </div>
    );
};
